<!-- warehouse_scan/public/js/components/Dialog.vue -->
<template>
  <div class="dialog-overlay" @click.self="handleClose">
    <div class="dialog-content" :class="sizeClass">
      <div class="dialog-header">
        <div class="dialog-title">
          <span v-if="icon" class="dialog-icon">{{ icon }}</span>
          {{ title }}
        </div>
        <button class="close-btn" @click="handleClose">✕</button>
      </div>
      
      <div class="dialog-body">
        <slot></slot>
      </div>
      
      <div v-if="$slots.footer" class="dialog-footer">
        <slot name="footer"></slot>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  title: {
    type: String,
    default: '提示'
  },
  icon: {
    type: String,
    default: ''
  },
  size: {
    type: String,
    default: 'medium',
    validator: (value) => ['small', 'medium', 'large', 'full'].includes(value)
  }
});

const emit = defineEmits(['close']);

const sizeClass = computed(() => {
  const classes = {
    small: 'dialog-small',
    medium: 'dialog-medium',
    large: 'dialog-large',
    full: 'dialog-full'
  };
  return classes[props.size] || 'dialog-medium';
});

const handleClose = () => {
  emit('close');
};
</script>

<style scoped>
.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  backdrop-filter: blur(3px);
  animation: fadeIn 0.2s ease;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.dialog-content {
  background: white;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(0,0,0,0.2);
  animation: slideUp 0.3s ease;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.dialog-small {
  width: 90%;
  max-width: 400px;
}

.dialog-medium {
  width: 90%;
  max-width: 500px;
}

.dialog-large {
  width: 90%;
  max-width: 700px;
}

.dialog-full {
  width: 95%;
  max-width: 1200px;
}

.dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 20px;
  background: #f8f9fa;
  border-bottom: 1px solid #f1f3f5;
  flex-shrink: 0;
}

.dialog-title {
  font-size: 18px;
  font-weight: 600;
  color: #2c3e50;
  display: flex;
  align-items: center;
  gap: 8px;
}

.dialog-icon {
  font-size: 20px;
}

.close-btn {
  width: 32px;
  height: 32px;
  border: none;
  background: transparent;
  color: #6c757d;
  font-size: 18px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s;
}

.close-btn:hover {
  background: #e9ecef;
}

.dialog-body {
  padding: 20px;
  overflow-y: auto;
  flex: 1;
}

.dialog-footer {
  padding: 15px 20px;
  border-top: 1px solid #f1f3f5;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  flex-shrink: 0;
}
</style>